import API, {APIRequestConfig} from "../API"
import getUrl from "./utils/getUrl"
import appendApolloClientValues from "./utils/appendApolloClientValues"
import setIfNotSet from "../../setIfNotSet"

export interface GraphRequest {
  query: any,
  variables?: any
}

const graph = ({query, variables}: GraphRequest, options: APIRequestConfig = {}) => {
  setIfNotSet(options, "isGraphQuery", true)
  return appendApolloClientValues(options).then(() => {
    return API.post(getUrl(), {query, variables}, options).then((res) => res.data.data)
  })
}

export default graph
export {getUrl}
